import { render } from "./row-col-base2.vue?vue&type=template&id=30616ba3&scoped=true"
import script from "./row-col-base2.vue?vue&type=script&lang=js"
export * from "./row-col-base2.vue?vue&type=script&lang=js"

import "./row-col-base2.vue?vue&type=style&index=0&id=30616ba3&lang=scss&scoped=true"

import exportComponent from "D:\\Afwct\\emis2.0\\emis-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30616ba3"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QField from 'quasar/src/components/field/QField.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSkeleton,QField,QTabPanel});
